/**
 * Themed Silhouette variant — barrel.
 *
 * Exports:
 *   WordSearchHub             — the variant's word-search landing page
 *   WordSearch                — the GameModule for the word-search slug
 *   Celebration / Affirmation — bespoke end-of-round surfaces
 *   manifest                  — small descriptor used by the variant selector
 */

export { Hub as WordSearchHub } from './Hub';
export { ThemedShapeWordSearchGame as WordSearch } from './Game';
export { Celebration } from './Celebration';
export { Affirmation } from './Affirmation';

export interface VariantManifest {
  slug: string;
  title: string;
}

export const manifest: VariantManifest = {
  slug: 'wordsearch-themedshape',
  title: 'A Shelf of Quiet Puzzles',
};
